var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container-item-wrapper', {
    attrs: {
      "widget": _vm.widget
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.widget.options.hidden),
      expression: "!widget.options.hidden"
    }],
    staticClass: "tab-container"
  }, [_c('el-tabs', {
    ref: _vm.widget.id,
    class: [_vm.customClass],
    attrs: {
      "type": _vm.widget.displayType
    },
    on: {
      "tab-click": _vm.handleTabClick
    },
    model: {
      value: (_vm.activeTabName),
      callback: function($$v) {
        _vm.activeTabName = $$v
      },
      expression: "activeTabName"
    }
  }, _vm._l((_vm.visibleTabs), function(tab, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": tab.options.label,
        "disabled": tab.options.disabled,
        "name": tab.options.name
      }
    }, [_vm._l((tab.widgetList), function(subWidget, swIdx) {
      return [('container' === subWidget.category) ? [_c(_vm.getComponentByContainer(subWidget), {
        key: swIdx,
        tag: "component",
        attrs: {
          "widget": subWidget,
          "parent-list": tab.widgetList,
          "index-of-parent-list": swIdx,
          "parent-widget": _vm.widget,
          "sub-form-row-id": _vm.subFormRowId,
          "sub-form-row-index": _vm.subFormRowIndex,
          "sub-form-col-index": _vm.subFormColIndex
        },
        scopedSlots: _vm._u([_vm._l((Object.keys(_vm.$scopedSlots)), function(slot) {
          return {
            key: slot,
            fn: function(scope) {
              return [_vm._t(slot, null, null, scope)]
            }
          }
        })], null, true)
      })] : [_c(subWidget.type + '-widget', {
        key: swIdx,
        tag: "component",
        attrs: {
          "field": subWidget,
          "parent-list": tab.widgetList,
          "index-of-parent-list": swIdx,
          "parent-widget": _vm.widget,
          "sub-form-row-id": _vm.subFormRowId,
          "sub-form-row-index": _vm.subFormRowIndex,
          "sub-form-col-index": _vm.subFormColIndex
        },
        scopedSlots: _vm._u([_vm._l((Object.keys(_vm.$scopedSlots)), function(slot) {
          return {
            key: slot,
            fn: function(scope) {
              return [_vm._t(slot, null, null, scope)]
            }
          }
        })], null, true)
      })]]
    })], 2)
  }), 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fcf33ee","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-render/container-item/tab-item.vue
// module id = null
// module chunks = 